import state from './Nextengine/states'
import mutations from './Nextengine/mutations'
import actions from './Nextengine/actions'
import getters from './Nextengine/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
